/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_Col_NextInputs */

const en_cap_money_mock_col_next = /** @type {(inputs: Cap_Money_Mock_Col_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step`)
};

const lv_cap_money_mock_col_next = /** @type {(inputs: Cap_Money_Mock_Col_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nākamais solis`)
};

/**
* | output |
* | --- |
* | "Next step" |
*
* @param {Cap_Money_Mock_Col_NextInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_col_next = /** @type {((inputs?: Cap_Money_Mock_Col_NextInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_Col_NextInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_col_next(inputs)
	return en_cap_money_mock_col_next(inputs)
});